module.exports = __webpack_public_path__ + "static/img/yinliang2.c9abe4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/yinliang2.png
// module id = YkoI
// module chunks = 24